import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    // Uses some common data structures
    'package:data.universal.commonStructures',
    'resource:data.dimensions.people',
    'resource:data.dimensions.people.entities.person',
    'resource:data.dimensions.people.entities.person.attributes.middle',
    'resource:data.dimensions.people.entities.person.attributes.last',
    'resource:data.dimensions.people.entities.person.attributes.first',
    'resource:data.dimensions.people.entities.person.attributes.contactInfo',
    'resource:data.dimensions.people.entities.person.attributes.userId',
  ],
  description: 'TODO',
  name: 'People',
} as const satisfies core.quiver.Package
